import { useState } from 'react'

import styled from 'styled-components'

import { media } from '../../../styles/breakpoints'

import { IconButtonExpand } from './components/IconButtonExpand'

export const ViewSelector = (
  props: React.PropsWithChildren<{
    title: string
    initialViewSelectorExpanded?: boolean
    viewingExpanded: boolean
    setViewingExpanded: (newValue: boolean) => void
    maxHeight?: React.CSSProperties['maxHeight']
    contentOverflow?: 'scroll' | 'visible'
    fitContent?: boolean
  }>,
) => {
  const [viewSelectorExpanded, setViewSelectorExpanded] = useState<boolean>(
    () => !!props.initialViewSelectorExpanded,
  )

  const onClickViewSelectorExpanded = (newValue: boolean) => {
    setViewSelectorExpanded(newValue)
    if (!newValue) {
      props.setViewingExpanded(false)
    } else {
      props.setViewingExpanded(true)
    }
  }

  return (
    <ViewSelectorContainer $fitContent={props.fitContent}>
      <HeaderContainer>
        <IconButtonExpand
          expanded={viewSelectorExpanded}
          onClick={onClickViewSelectorExpanded}
          style={{ margin: '0px 5px', display: 'inline-flex' }}
          size={20}
        />

        <SectionHeader style={{ display: 'inline', fontSize: '8px' }}>{`${
          viewSelectorExpanded ? 'Hide' : 'Show'
        } ${props.title}`}</SectionHeader>
      </HeaderContainer>

      <ContentContainer
        aria-expanded={viewSelectorExpanded}
        maxHeight={props.maxHeight}
        $contentOverflow={props.contentOverflow}
        $fitContent={props.fitContent}
      >
        {props.children}
      </ContentContainer>
    </ViewSelectorContainer>
  )
}

export const HeaderContainer = styled.div`
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 10px;
`

export const SectionHeader = styled.h2`
  color: #686868;
  opacity: 0.64;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  line-height: 16px;
`

const ViewSelectorContainer = styled.div<{ $fitContent?: boolean }>`
  margin: 20px 0px 0px 0px;
  background: #ffffff;
  box-shadow: 0px 8px 20px rgba(106, 106, 106, 0.1);
  border-radius: 4px;
  width: 250px;
  padding: 8px;
  height: ${props => (props.$fitContent ? 'auto' : '100%')};
  flex-shrink: 0;

  @media ${media.belowTablet} {
    width: 100%;
    margin: 0 0 12px;
    box-sizing: border-box;
  }
`

export const ContentContainer = styled.div<{
  maxHeight?: React.CSSProperties['maxHeight']
  $contentOverflow?: 'scroll' | 'visible'
  $fitContent?: boolean
}>`
  max-height: 0;
  overflow: ${props => props.$contentOverflow ?? 'scroll'};
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  transition: max-height 0.5s;
  &[aria-expanded='true'] {
    max-height: ${props => {
      if (props.$fitContent) {
        return '2000px'
      }
      return props.maxHeight
        ? typeof props.maxHeight === 'number'
          ? `${props.maxHeight}px`
          : props.maxHeight
        : '750px'
    }};
  }
`
